module.exports = __webpack_public_path__ + "img/pm1.fea0d9ab.png";